<template>
  <div>
    <a class="change-service" v-show="hasService" @click="changeService(leg)"><span>{{ $t('serviceSelect.changeSelect') }}</span></a>
  </div>
</template>

<script>
export default {
  name: 'change-service',
  props: ['leg'],
  data () {
    return {
    }
  },
  computed: {
    hasService () { return this.$store.state.reservation.leg1.selectedService !== '' },
    charter () { return this.$store.state.reservation.charter }
  },
  methods: {
    changeService (leg) {
      this.$store.state.reservation[leg].selectedService = ''
      if (leg === 'leg1') {
        this.$store.state.reservation['leg2'].selectedService = ''
      }
      this.$store.commit('setCurrentIndex', 0)
      this.$store.commit('disablePreviousSteps', 3)
    }
  },
  watch: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.change-service{
  position: absolute;
  top: 25px;
  right: 20px;
  padding: 2px 8px;
  border-radius: 3px;
  box-shadow: 1px 1px 2px rgba(0,0,0, .3);
  border: 1px solid rgba(0,0,0, .25);
  
  span{
    color: #fff!important;
  }
}

@media only screen and (max-width: 460px) {
  .change-service{
    line-height: 1;
    left: 20px;
    top: 60px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ChangeService.vue?930f7c6c